import * as React from 'react'
import * as cl from 'classnames'
import {
  INameState
} from '../types'


export default class Result extends React.PureComponent<{
  result: string
  base: string
  state: INameState
  onShow: (name: string) => void
}> {

  onShow = () => {
    this.props.onShow(this.props.result)
  }

  renderContent() {
    const {
      result,
      base
    } = this.props

    if (result.startsWith(base)) {
      const suffix = result.slice(base.length)

      return (
        <span>
          <strong className="result-spacer">{suffix}</strong>{base}<strong>{suffix}</strong>
        </span>
      )

    } else {
      const prefix = result.slice(0, result.length - base.length)

      return (
        <span>
          <strong>{prefix}</strong>{base}<strong className="result-spacer">{prefix}</strong>
        </span>
      )
    }
  }

  render() {
    const {
      state
    } = this.props

    return (
      <div
        className={cl('result', state == 'taken' && 'result-unavailable')}
      >
        <span
          onClick={this.onShow}
        >
          {this.renderContent()}
        </span>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/result.tsx